import axios from "axios";
import { put, takeEvery } from "redux-saga/effects";
import {
    GET_USER_CLASS_TYPE,
    GET_DISPLAY_NAME_MAPPING,
    GetAllUserClassTypeAction,
    GetDisplaynameMappingAction,
    AllUserClassTypeReceivedAction,
    DisplayNameMappingReceivedAction
} from "../actions/publicViewer/types";
import { allUserClassTypeReceived, displayNameMappingReceived } from "../actions/publicViewer";

import { showError } from "../components/commonUtilities";
import { decrypt } from "../Utilities/decryption";
import { GeneratorYieldType } from "../interfaces/ActionReducer/GetMethod/GetResponse";

function* getAllUserClassType(
    action: GetAllUserClassTypeAction
): Generator<
    | Promise<AllUserClassTypeReceivedAction>
    | GeneratorYieldType<AllUserClassTypeReceivedAction["payload"]>,
    void,
    AllUserClassTypeReceivedAction["payload"]
> {
    try {
        let json = yield axios
            .get("/api/user-class-category/", { params: action.payload.params })
            .then((response) => response.data);

        json = decrypt(json);

        yield put(allUserClassTypeReceived({ allUserClassTypeReceived: json }));
    } catch (e) {
        showError(e);
    }
}

export function* getAllUserClassTypeSaga() {
    yield takeEvery(GET_USER_CLASS_TYPE, getAllUserClassType);
}

function* getDisplayNameMapping(
    action: GetDisplaynameMappingAction
): Generator<
    | Promise<DisplayNameMappingReceivedAction>
    | GeneratorYieldType<DisplayNameMappingReceivedAction["payload"]>,
    void,
    DisplayNameMappingReceivedAction["payload"]["displayNameMappingReceived"]
> {
    try {
        let json = yield axios
            .get("/api/display-name-combination/", { params: action.payload.params })
            .then((response) => response.data);

        json = decrypt(json);

        yield put(displayNameMappingReceived({ displayNameMappingReceived: json }));
    } catch (e) {
        showError(e);
    }
}

export function* getDisplayNameMappingSaga() {
    yield takeEvery(GET_DISPLAY_NAME_MAPPING, getDisplayNameMapping);
}
